import React, { useState } from "react";
import NavbarAdmin from "../../Components/NavbarAdmin/NavbarAdmin";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getShowMenuManager, inventory } from "../../Helpers/apiCalls/menuManagerApi";
import { useNavigate } from "react-router-dom";
import ReactLoading from "react-loading";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { toastStyle } from "../../Helpers/Utils/Common";

export default function MenuManager() {

    const [inactive, setInactive] = useState(false);
    
    const {id} = useParams()
    const navigate = useNavigate()
    const [menuDetails, setMenuDetails] = useState({})
    const [menuQty, setMenuQty] = useState(0)
    const [isClicked, setIsClicked] = useState(false)

    async function getShowMenu(){
        const response = await getShowMenuManager(id);
        if(response.data){
            setMenuDetails(response.data)
        }
      }

      async function handleInventory() {
        setIsClicked(true)
        if(menuQty > 0){
            setIsClicked(true)
            const response = await inventory(id, menuQty);
            if (response.data) {
            toast.success(response.data.message.success);
                navigate("/menuManager");
                setIsClicked(false)
            } else {
                toast.error(response.data.message.success);
                setIsClicked(false)
            }
        }else{
            toast.error("Please input quantity!", {style: toastStyle(),});
            setIsClicked(false)
        }
        setIsClicked(false)
      } 

    React.useEffect (() => {
        getShowMenu();
    },[])

    return (
        <div>
        <div className="page">
            <Toaster position="top-right" reverseOrder={false} />
           <NavbarAdmin
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"Menus"}
                    page={"Menus"}
                />
            <div className={`container ${inactive ? "inactive" : "active"}`}>
                <Row className="mb-3">
                    <Col xl={6}>
                        <h1 className="page-title-menu">  INVENTORY </h1>
                    </Col>
                    <Col sm={6}></Col>
                </Row>
                <hr/>
                <Row className="b-shadow count-border-cc rounded mx-h-30 mx-w-30 mb-4">
                    <Row className="mb-3 mt-3">
                        <Col sm={6}>
                            <Form.Label className="inventory-text">ITEM</Form.Label>
                        </Col>
                        <Col sm={6}>
                            <Form.Label className="inventory-text">QUANTITY</Form.Label>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col sm={6}>
                            <Form.Label>{menuDetails.name}</Form.Label>
                        </Col>
                        <Col sm={6}>
                            <Form.Control placeholder="Enter quantity..." onChange={(e)=> setMenuQty(e.target.value)}></Form.Control>
                        </Col>
                    </Row>
                </Row>
                <Row className="mb-3">
                    <Col sm={6}></Col>
                    <Col sm={3} className="right">
                        <Button size={"md"} variant="info" className="button-secondary" onClick={() => navigate(-1)}>Back</Button>
                    </Col>
                    <Col sm={3} className="d-flex justify-content-center">
                        {isClicked ? 
                            <div className="button-tertiary me-3 d-flex justify-content-center">
                                <ReactLoading
                                    type="bubbles"
                                    color="var(--primary-color)"
                                    height={50}
                                    width={50}
                                />
                            </div>
                        :
                            // menuQty > 0 ?
                                <Button size={"md"} variant="success" className="button-primary" onClick={handleInventory}>Save</Button>
                            // :
                            //     <Button size={"md"} variant="success" style={{ width: "100%", backgroundColor: "var(--secondary-color", border:"none", color: "#aaa" }} onClick={handleInventory}>Save</Button>
                        }
                    </Col>
                </Row>
            </div>
        </div>
        </div>
    );
}